import { ModalData } from '../../../../../shared/components/modal/models/modal-data';

export class MasqueradeModalConfig {
    public static getDialogConfig(
        fullName: string,
        action: () => void,
    ): ModalData {
        const content = `This action will allow you to act and make changes as <span class="font-medium">${fullName}</span>, are you sure you want to continue?`;

        return {
            title: 'Begin Masquerade',
            content: content,
            primaryAction: {
                name: 'Masquerade',
                title: 'Continue',
                classList: '!bg-error-700 !text-tertiary-50',
                action: action,
            },
        };
    }
}
